export const countryOptions: string[] = ["BE", "FR"]

export interface Address {
  "@id"?: string;
  id?: number;
  address1?: string;
  address2?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  readonly fullAddress?: string;
}
